import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import { addMethod, array } from 'yup';

const ARRAY_SEPARATOR = '~';

const EMPTY_ARRAY_CONST = 'EMPTYARR';

class SeparatorReplacer {
  constructor(separator) {
    const parts = uniq(separator.split('')); // ['_', '_'];
    this.replacePairs = parts.map((p, i) => [p, `SEP${i}SEP`]);
  }
  encode(value) {
    return this.replacePairs.reduce((v, [part, placeholder]) => {
      return v.replace(new RegExp(part, 'g'), placeholder);
    }, value);
  }
  decode(value) {
    return this.replacePairs.reduce((v, [part, placeholder]) => {
      return v.replace(new RegExp(placeholder, 'g'), part);
    }, value);
  }
}

addMethod(array, 'encodeSeparator', function (separator) {
  const next = this.clone();
  next._separator = separator;
  return next;
});

addMethod(array, '_isEqual', function (value, otherValue) {
  return isEqual(value, otherValue);
});

addMethod(array, 'stringify', function (value, options = {}) {
  if (value === undefined) {
    return undefined;
  }
  const sep = this._separator || ARRAY_SEPARATOR;
  const sepReplacer = new SeparatorReplacer(sep);

  if (!value.length) {
    return EMPTY_ARRAY_CONST;
  }

  return value
    .map((el) => this._subType.stringify(el, options))
    .map((strValue) => (strValue ? sepReplacer.encode(strValue) : strValue))
    .join(sep);
});

addMethod(array, 'parse', function (stringValue, options) {
  if (stringValue === '') {
    return undefined;
  } else if (stringValue === EMPTY_ARRAY_CONST) {
    return [];
  }

  const sep = this._separator || ARRAY_SEPARATOR;
  const sepReplacer = new SeparatorReplacer(sep);

  const res = stringValue
    .split(sep)
    .map((v) => (v === undefined ? '' : v))
    .map((strV) => {
      return this._subType.parse(sepReplacer.decode(strV, options));
    });

  return res;
});

export default array;
